// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"45c057bf","322":"76c87adb","493":"02b47d03","514":"bc7e72cb","728":"59165abd","824":"d9c1fd76","994":"48b2c4dd"}[chunkId] + ".chunk.js";
};